import * as React from "react";
import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import { AcceptCookies, TealiumAnalytics } from "../modules/cdp-analytics";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      minHeight: "100vh",
      flexDirection: "column",
      overflow: "hidden",
      background: "rgba(242, 245, 243, 0.5)",
      width: "100%",
    },
  });

type Props = WithStyles<typeof styles> & { isExport?: boolean };

class Layout extends React.Component<Props> {
  render() {
    const { classes, children, isExport } = this.props;
    return (
      <div className={classes.root}>
        {isExport ? null : (
          <>
            <TealiumAnalytics />
          </>
        )}

        {children}
      </div>
    );
  }
}

export default withStyles(styles)(Layout);
